import { useTranslation } from 'react-i18next';
import { Button } from '@/shared/components/ui/button';
import { FiltersPopover } from '@/shared/components/custom/filters-popover';
import { FloatingLabelInput } from '@/shared/components/custom/form-field/FloatingLabelInput';

interface ClientMembersFiltersProps {
  search: string;
  onSearchChange: (value: string) => void;
  activeFiltersCount: number;
  onReset: () => void;
}

export function ClientMembersFilters({
  search,
  onSearchChange,
  activeFiltersCount,
  onReset,
}: ClientMembersFiltersProps) {
  const { t } = useTranslation('client-members');

  return (
    <FiltersPopover activeCount={activeFiltersCount} label={t('filters.trigger')}>
      <FiltersPopover.Content>
        <FloatingLabelInput
          id="client-members-search"
          label={t('filters.search')}
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          hasValue={!!search}
        />
        {activeFiltersCount > 0 && (
          <Button variant="ghost" size="sm" onClick={onReset} className="w-full">
            {t('filters.reset')}
          </Button>
        )}
      </FiltersPopover.Content>
    </FiltersPopover>
  );
}
